import { useState, useEffect, useRef, useMemo, Suspense } from "react";
import { useLocation } from "react-router-dom";
import { Canvas, useThree } from "@react-three/fiber";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import Confetti from "react-confetti";
import { useTexture } from "@react-three/drei";
import * as THREE from "three";
import gsap from "gsap";
import Spinner from "react-bootstrap/Spinner";

import {
  game_1,
  game_2,
  game_3,
  game_4,
  game_5,
  game_6,
  game_7,
  game_8,
  game_9,
  game_10,
  game_11,
  game_12,
} from "../../utils/constants";
import SceneOne from "./Background-scene/SceneOne";
import SceneThree from "./Background-scene/SceneThree";
import LevelOne from "./Level-1";
import LevelTwo from "./Level-2";
import LevelThree from "./Level-3";
import LevelFour from "./Level-4";
import LevelFive from "./Level-5";
import LoadingBarGIF from "../../assets/loading-bar 1.gif";

const Loader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        height: "100vh",
        alignItems: "center",
       
      }}
    >
      {/* <Spinner
        animation="border"
        role="status"
        style={{ width: "100px", height: "100px" }}
        variant="secondary"
        size="lg"
      >
        <span className="visually-hidden">Loading...</span>
      </Spinner> */}
      <img src={LoadingBarGIF} />
    </div>
  );
};

const CameraController = () => {
  const { camera, gl } = useThree();

  useEffect(() => {
    const controls = new OrbitControls(camera, gl.domElement);

    // controls.minPolarAngle = Math.PI/2;

    // controls.maxPolarAngle = Math.PI/2;

    return () => {
      controls.dispose();
    };
  }, [camera, gl]);
  return null;
};

function BackgroundImage({ imageUrl }) {
  const mesh = useRef();

  return (
    <mesh ref={mesh}>
      <planeGeometry args={[30, 30]} />
      <meshBasicMaterial>
        <texture
          attach="map"
          minFilter={THREE.LinearFilter}
          colorSpace={THREE.SRGBColorSpace}
          image={imageUrl}
          onUpdate={(texture) => {
            texture.needsUpdate = true;
          }}
        />
      </meshBasicMaterial>
    </mesh>
  );
}

export const NextButton = ({
  currentLevel,
  setNextLevel,
  showPlayButton,
  setShowPlayButton,
}) => {
  const ref = useRef();
  const { camera, gl } = useThree();
  const [userClicked, setUserClicked] = useState(false);
  const loader = new THREE.TextureLoader();

  const width = window.innerWidth;
  const height = window.innerHeight;
  const aspect = width / height;

  // const [worldPosition, setWorldPosition] = useState({left: {x:0,y:0,z:0}, right: {x:0, y:0, z:0}})

  const leftOval = useMemo(() => loader.load("PlayButton.webp"));

  leftOval.colorSpace = THREE.SRGBColorSpace;
  leftOval.minFilter = THREE.LinearFilter;

  const offset = new THREE.Vector3(0, 0, 2);
  const raycaster = new THREE.Raycaster();
  const mouse = new THREE.Vector2();
  //animation loop

  useEffect(() => {
    setTimeout(() => {
      if (ref.current) {
        setUserClicked(false);
        // LeftRighBack();
      }
    }, 500);
  }, []);

  useEffect(() => {
    const timer = setTimeout(
      () => {
        if (!userClicked) {
          if (currentLevel <= 4) {
            setNextLevel(currentLevel + 1);
          }
        }
      },
      currentLevel <= 2 ? 25000 : 25000
    );
    return () => {
      clearTimeout(timer);
    };
  }, [currentLevel]);

  function LeftRighBack() {
    var vector = new THREE.Vector2();

    vector.x = ((vector.x / 1) * window.innerWidth) / window.innerHeight;
    vector.y = ((-vector.y / 1) * window.innerHeight) / window.innerHeight;

    gsap.to(ref.current.children[0].position, {
      x: aspect * -0.5,
      y: -aspect,
      onComplete: () => {
        const position = new THREE.Vector3();
        ref.current.children[0].getWorldPosition(position);
        const xPosition = ref.current.children[0].scale.x - position.x;
      },
    });
    return vector;
  }

  function onMouseClick(event, name) {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    raycaster.setFromCamera(mouse, camera);

    var vector = new THREE.Vector3(
      (event.clientX / window.innerWidth) * 2 - 1,
      -(event.clientY / window.innerHeight) * 2 + 1,
      0.5
    );
    var raycasterr = new THREE.Raycaster(
      camera.position,
      vector.sub(camera.position).normalize()
    );
    raycasterr.setFromCamera(vector, camera);

    // var intersectss = raycasterr.intersectObjects(ref.current.children, false);

    // alternative
    var intersectss = ref.current.children?.filter((itm) => itm.name === name);

    for (let i = 0; i < intersectss.length; i++) {
      const intersectedObject = ref.current.children[i];

      document.body.style.cursor = "pointer";
      setUserClicked(true);
      if (currentLevel <= 4) {
        setNextLevel(currentLevel + 1);
      }
    }
  }

  const handleClick = () => {
    setShowPlayButton(false);
  };

  return (
    <group ref={ref}>
      {/*<mesh
        name={"btn"}
        scale={[1, 1, 1]}
        onClick={(e) => {
          onMouseClick(e, "btn");
          // handleClick();
        }}
      >
        <sprite>
          <spriteMaterial attach={"material"} map={leftOval} />
        </sprite>
      </mesh>*/}
    </group>
  );
};

export const PlayButton = ({ showPlayButton, setShowPlayButton }) => {
  const ref = useRef();
  const { camera, gl } = useThree();
  const [userClicked, setUserClicked] = useState(false);
  const loader = new THREE.TextureLoader();

  const width = window.innerWidth;
  const height = window.innerHeight;
  const aspect = width / height;

  // const [worldPosition, setWorldPosition] = useState({left: {x:0,y:0,z:0}, right: {x:0, y:0, z:0}})

  const leftOval = useMemo(() => loader.load("PlayButton.webp"));

  leftOval.colorSpace = THREE.SRGBColorSpace;
  leftOval.minFilter = THREE.LinearFilter;

  return (
    <group ref={ref}>
      <mesh
        name={"btn"}
        scale={[1, 1, 1]}
        onClick={(e) => {
          setShowPlayButton(!showPlayButton);
        }}
      >
        <sprite>
          <spriteMaterial attach={"material"} map={leftOval} />
        </sprite>
      </mesh>
    </group>
  );
};

const TwoDD = () => {
  const ref = useRef();

  const location = useLocation();
  const [level, setLevel] = useState(0);
  const [nextLevel, setNextLevel] = useState(0);
  const [multipleObj, setMultipleObj] = useState([]);
  const [confetti, setConfetti] = useState({ run: false, ratio: 0 });

  const [showNext, setShowNext] = useState(false);
  const [showPlayButton, setShowPlayButton] = useState(true);

  const [changeBackground, setChangeBackground] = useState("");
  const [gameID, setGameID] = useState(0);
  const [clickNext, setClickNext] = useState(false);

  const games = [
    game_1,
    game_2,
    game_3,
    game_4,
    game_5,
    game_6,
    game_7,
    game_8,
    game_9,
    game_10,
    game_11,
    game_12,
  ];

  const [iterItem, setIterItem] = useState({
    letter: "",
    letterImg: "",
    objectImg: "",
    nameImg: "",
    music: "",
    name: "",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
  });

  const width = window.innerWidth;
  const height = window.innerHeight;
  const aspect = width / height;

  const [worldPosition, setWorldPosition] = useState(null);

  const [i, setI] = useState(-1);

  function my() {
    setI(i + 1);

    if (i + 1 === games.length - 1) {
      setI(-1);
    }
  }

  const shuffleArray = (arr) => {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  };

  const [newArray, setNewArray] = useState([]);
  const [nextClick, setNextClick] = useState(0);

  useEffect(() => {
    setGameID(parseInt(location?.pathname?.split("-")[2]));
  }, [nextLevel, location]);

  useEffect(() => {
    if (nextLevel) {
      setShowNext(false);
      setLevel(nextLevel);
    }
  }, [nextLevel]);

  useEffect(() => {
    if (gameID) {
      // navigator.mediaDevices
      //   .getUserMedia({
      //     audio: true,
      //     video: false,
      //   })
      //   .then((stream) => {
      //     console.log(129, stream);
      //  });
      // navigator.mediaDevices
      //   .enumerateDevices()
      //   .then((devices) => {
      //     const hasAudioInput = devices.some(
      //       (device) => device.kind === "audioinput"
      //     );

      //     if (hasAudioInput) {
      //       // Attempt to get the user's media stream
      //       navigator.mediaDevices
      //         .getUserMedia({ audio: true, video: false })
      //         .then((stream) => {
      //           console.log("Stream obtained:", stream);
      //         })
      //         .catch((error) => {
      //           if (error.name === "NotAllowedError") {
      //             console.log("Permissions have been denied.");
      //             // Handle the error or prompt the user to enable permissions
      //           } else {
      //             console.error("Error accessing media devices:", error);
      //           }
      //         });
      //     } else {
      //       console.log("No audio input devices found.");
      //       // Handle the case where no audio input devices are available
      //     }
      //   })
      //   .catch((error) => {
      //     console.error("Error ePnumerating devices:", error);
      //   });

      if (gameID === 1 || gameID === 10) {
        setLevel(1);
      } else {
        setLevel(2);
      }
    }
  }, [gameID]);

  useEffect(() => {
    // setNewArray(shuffleArray([...game_1]));
    if (gameID) {
      setNewArray(shuffleArray([...games[gameID - 1]]));
      setNextClick(0);
    }
  }, [level]); // level

  useEffect(() => {
    if (gameID && !showPlayButton) {
      setTimeout(() => {
        if (level === 1 && !showNext && nextClick <= 2) {
          setChangeBackground("square");

          setI(i + 1);
          const item = newArray[i + 1];

          setIterItem({
            letter: item.letter,
            letterImg: item.letterImg,
            objectImg: item.objectImg,
            nameImg: item.nameImg,
            music: item.music,
            wordMusic: item.wordMusic,
            name: item.name,
            wordCount: item.wordCount,
          });
          if (i + 1 === newArray.length - 1) {
            setI(-1);
            // setLevel(level+1)
            setShowNext(true);
          }
        }
        if (level === 2 && !showNext && nextClick <= 2) {
          // setWorldPosition(null)
          setChangeBackground("square");
          setI(i + 1);
          const item = newArray[i + 1];

          setIterItem({
            letter: item.letter,
            letterImg: item.letterImg,
            objectImg: item.objectImg,
            nameImg: item.nameImg,
            music: item.music,
            wordMusic: item.wordMusic,
            name: item.name,
            wordCount: item.wordCount,
          });
          if (i + 1 === newArray.length - 1) {
            setI(-1);
            // setLevel(level+1)
            setShowNext(true);
          }
        }
        if (level === 3 && !showNext && nextClick <= 2) {
          // setWorldPosition(null);
          // setChangeBackground("ovals");
          // setChangeBackground("ovals");

          setMultipleObj([]);

          setI(i + 1);
          const itemm = newArray[i + 1];
          var availableIndexes = newArray.filter(
            (itm) => itm.letter !== itemm.letter
          );

          const twoElement = availableIndexes
            .sort(() => Math.random() - Math.random())
            .slice(0, 2);

          twoElement.push({
            mainLetter: itemm.letter,
            letter: itemm.letter,
            letterImg: itemm.letterImg,
            objectImg: itemm.objectImg,
            nameImg: itemm.nameImg,
            music: itemm.music,
            wordMusic: itemm.wordMusic,
            name: itemm.name,
            Yay: itemm.yay,
            y: itemm.y,
            wordCount: itemm.wordCount,
          });
          const NewShuffle = shuffleArray([...twoElement]);

          setTimeout(() => {
            setMultipleObj(NewShuffle);
          }, 500);
          setTimeout(() => {
            // setWorldPosition(null)
          }, 15500);
          if (i + 1 === newArray.length - 1) {
            setI(-1);
            // setLevel(level+1)
            setShowNext(true);
          }
        }
        if (level === 4 && !showNext && nextClick <= 2) {
          // setChangeBackground("ovals");

          setTimeout(() => {
            setMultipleObj([]);
            setI(i + 1);
            const itemm = newArray[i + 1];
            var availableIndexes = newArray.filter(
              (itm) => itm.letter !== itemm.letter
            );

            const twoElement = availableIndexes
              .sort(() => Math.random() - Math.random())
              .slice(0, 2);

            twoElement.push({
              mainLetter: itemm.letter,
              letter: itemm.letter,
              letterImg: itemm.letterImg,
              objectImg: itemm.objectImg,
              nameImg: itemm.nameImg,
              music: itemm.music,
              wordMusic: itemm.wordMusic,
              name: itemm.name,
              Yay: itemm.yay,
              y: itemm.y,
            });
            const NewShuffle = shuffleArray([...twoElement]);
            setMultipleObj(NewShuffle);
            setTimeout(() => {
              // setWorldPosition(null)
            }, 14500);
            if (i + 1 === newArray.length - 1) {
              setI(-1);
              // setLevel(level+1)
              setShowNext(true);
            }
          }, 1000);
        }
        if (level === 5 && !showNext) {
          // setChangeBackground("ovals");
          setMultipleObj([]);
          setTimeout(() => {
            setI(i + 1);
            const itemm = newArray[i + 1];
            var availableIndexes = newArray.filter(
              (itm) => itm.letter !== itemm.letter
            );

            const twoElement = availableIndexes
              .sort(() => Math.random() - Math.random())
              .slice(0, 2);
            twoElement.push({
              mainLetter: itemm.letter,
              letter: itemm.letter,
              letterImg: itemm.letterImg,
              objectImg: itemm.objectImg,
              nameImg: itemm.nameImg,
              music: itemm.music,
              wordMusic: itemm.wordMusic,
              name: itemm.name,
              Yay: itemm.yay,
              y: itemm.y,
            });
            const NewShuffle = shuffleArray([...twoElement]);
            setMultipleObj(NewShuffle);

            if (i + 1 === newArray.length - 1) {
              setI(-1);
              // setLevel(level+1)
              setShowNext(true);
            }
          }, 1000);
        }
      }, 1000);
    }
  }, [newArray, nextClick, showPlayButton]); //  newArray, nextClick

  function getRandomItems(arr, num) {
    // Create a copy of the game_1 to avoid mutating the original game_1
    const arrayCopy = [...arr];

    // Fisher-Yates shuffle algorithm
    for (let i = arrayCopy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arrayCopy[i], arrayCopy[j]] = [arrayCopy[j], arrayCopy[i]];
    }

    // Return the first 'num' items from the shuffled game_1
    return arrayCopy.slice(0, num);
  }

  return (
    <div>
     
      {/* <button onClick={() => { setNextClick(!nextClick) }}>next</button> */}
      {confetti?.run && (
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
          numberOfPieces={confetti.ratio * 400}
          opacity={confetti.ratio !== 1 ? 0.6 : 1}
        />
      )}

      <Canvas style={{ width: window.innerWidth, height: window.innerHeight }}>
        {/*  fov: 50, aspect: aspectRatio, position: [0,0.2, 1.8] */}
        <Suspense fallback={<Loader />}>
          <ambientLight intensity={1} />
          
          <Background level={level} setWorldPosition={setWorldPosition} />
          {/* {(level === 1 || level === 2) ? (
          <SceneOne level={level} setWorldPosition={setWorldPosition} />
        ) : (level === 3 || level === 4 || level === 5) ? (
          <SceneThree
            level={level}
            setWorldPosition={setWorldPosition}
            changeBackground={changeBackground}
          />
        ) : (
          <></>
        )} */}

          {showNext && ( // showNext
            <NextButton
              currentLevel={level}
              setNextLevel={setNextLevel}
              showPlayButton={showPlayButton}
              setShowPlayButton={setShowPlayButton}
            />
          )}

          {showPlayButton && (
            <PlayButton
              showPlayButton={showPlayButton}
              setShowPlayButton={setShowPlayButton}
            />
          )}
          {!showPlayButton && (
            <>
              {iterItem?.letter && level === 1 && (
                <LevelOne
                  // worldPosition={worldPosition}
                  letter={iterItem.letter}
                  letterImg={iterItem.letterImg}
                  objectImg={iterItem.objectImg}
                  nameImg={iterItem.nameImg}
                  name={iterItem.name}
                  music={iterItem.music}
                  wordMusic={iterItem.wordMusic}
                  wordCount={iterItem.wordCount}
                  nextClick={nextClick}
                  setNextClick={setNextClick}
                />
              )}

              {level === 2 && (
                <LevelTwo
                  // worldPosition={worldPosition}
                  letter={iterItem.letter}
                  letterImg={iterItem.letterImg}
                  objectImg={iterItem.objectImg}
                  nameImg={iterItem.nameImg}
                  name={iterItem.name}
                  music={iterItem.music}
                  wordMusic={iterItem.wordMusic}
                  setConfetti={setConfetti}
                  Yay={"PHONIC SOUND/YAY/Yay.mp3"}
                  halfY={"PHONIC SOUND/YAY/Y.mp3"}
                  nextClick={nextClick}
                  setNextClick={setNextClick}
                  wordCount={iterItem.wordCount}
                />
              )}

              {level === 3 && multipleObj?.length > 0 && (
                <LevelThree
                  data={multipleObj}
                  // worldPosition={worldPosition}
                  setConfetti={setConfetti}
                  setChangeBackground={setChangeBackground}
                  Yay={"PHONIC SOUND/YAY/Yay.mp3"}
                  halfY={"PHONIC SOUND/YAY/Y.mp3"}
                  nextClick={nextClick}
                  setNextClick={setNextClick}
                />
              )}

              {level === 4 && multipleObj?.length > 0 && (
                <LevelFour
                  data={multipleObj}
                  // worldPosition={worldPosition}
                  setConfetti={setConfetti}
                  setChangeBackground={setChangeBackground}
                  Yay={"PHONIC SOUND/YAY/Yay.mp3"}
                  halfY={"PHONIC SOUND/YAY/Y.mp3"}
                  nextClick={nextClick}
                  setNextClick={setNextClick}
                />
              )}

              {level === 5 && multipleObj?.length > 0 && (
                <LevelFive
                  data={multipleObj}
                  // worldPosition={worldPosition}
                  setConfetti={setConfetti}
                  setChangeBackground={setChangeBackground}
                  Yay={"PHONIC SOUND/YAY/Yay.mp3"}
                  halfY={"PHONIC SOUND/YAY/Y.mp3"}
                  nextClick={nextClick}
                  setNextClick={setNextClick}
                />
              )}
            </>
          )}

          {/* <CameraController /> */}
        </Suspense>
      </Canvas>

     
    </div>
  );
};

const Background = ({ level, setWorldPosition }) => {
  const loader = new THREE.TextureLoader();
  const texture = useMemo(() => loader.load("/BG.webp"), []);
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.minFilter = THREE.LinearFilter;
  // texture.magFilter = THREE.NearestFilter

  return (
            <>
          <primitive attach="background" object={texture} normalMap={texture} />
          {/* <MainScene level={level} setWorldPosition={setWorldPosition} /> */}
            </>

    // object={formatted.texture}
  );
};

export default TwoDD;
